//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Grid, Container } from '@mui/material';
import BackForwardNav from '../FilesContainer/BackForwardNav';
import Path from '../FilesContainer/Path/Path';
import FileQueue from './FileQueue';

const ActionBar = () => {
  return (
    <Container sx={{ mb: 2, whiteSpace: 'nowrap' }}>
      <Grid container justifyContent="space-between" alignItems="flex-end" flexWrap="nowrap">
        <Grid item container alignItems="center" wrap="nowrap">
          <Grid item>
            <BackForwardNav />
          </Grid>
          <Grid item>
            <Path />
          </Grid>
        </Grid>
        <Grid container item justifyContent="flex-end" alignItems="center">
          <FileQueue />
        </Grid>
      </Grid>
    </Container>
  );
};
export default ActionBar;
